import {Checkbox, FormControl, FormControlLabel, LinearProgress} from '@material-ui/core';
import Grow from "@material-ui/core/Grow";
import {FilterEnum} from 'Agent/Accounts/ducks/account';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import React from 'react';
import './DropDownFilter.sass';

export type MultiSelectProps = {
  value: FilterOptionUnion[];
  onChange: (filter: FilterOptionUnion[]) => any;
  multiple: true;
};

export type SingleSelectProps = {
  value: FilterOptionUnion;
  onChange: (filter: FilterOptionUnion) => any;
  multiple: false;
};

export type DropDownFilterProps = (MultiSelectProps | SingleSelectProps) & {
  label: string;
  items: FilterEnum[];
};

const DropDownFilter = (props: DropDownFilterProps) => {
  let value: string;
  let values: string[];

  const match = (filterOption: FilterOptionUnion) =>
    FilterOptionValue.match(filterOption, {
      EmptyOption: () => '',
      SelectedOption: option => option.value,
    });

  if (props.value) {
    if (props.multiple) {
      values = props.value.map(match);
    } else {
      // @ts-ignore
      value = match(props.value);
    }
  }

  return (
    <>
      <p className="dropdown-filter__label">{props.label}</p>
      <FormControl fullWidth>
          <Grow in={props.items.length <1}>
            <LinearProgress style={{width: '10vw', justifyContent: 'center'}} />
          </Grow>
        {props.items.map(item => {
          return (
            <FormControlLabel
              label={item.name}
              key={`status-label__${item.name}`}
              control={
                <Checkbox
                  checked={props.multiple ? values.includes(item.value) : item.value === value}
                  key={item.name}
                  value={item.value}
                  onChange={event => {
                    if (props.multiple) {
                      const selectedOptions = props.items
                        .filter(i => i.name !== item.name)
                        .map(i =>
                          values.includes(i.value)
                            ? FilterOptionValue.SelectedOption(i)
                            : FilterOptionValue.EmptyOption()
                        )
                        .filter(i => i.tag !== 'EmptyOption');

                      if (event.currentTarget.checked) {
                        props.onChange([...selectedOptions, FilterOptionValue.SelectedOption(item)]);
                      } else {
                        props.onChange([...selectedOptions]);
                      }
                    } else {
                      if (event.currentTarget.checked) {
                        // @ts-ignore
                        props.onChange(FilterOptionValue.SelectedOption(item));
                      } else {
                        // @ts-ignore
                        props.onChange(FilterOptionValue.EmptyOption());
                      }
                    }
                  }}
                />
              }
            />
          );
        })}
      </FormControl>
    </>
  );
};

export default DropDownFilter;
